module.exports = __webpack_public_path__ + "img/cv-template-8.df341b2f.png";